import {
  apiGetAssessmentFile,
  apiInviteToAssessmentFileBulk,
  apiMarkAsExample,
  apiUnmarkAsExample,
  apiEditTitle,
  apiCloseAssessmentFile,
  apiReopenAssessmentFile,
  apiMarkAsBenchmark,
  apiUnmarkAsBenchmark,
  apiMarkAsTrainingMaterial,
  apiUnmarkAsTrainingMaterial,
  apiMarkAsPremium,
  apiUnmarkAsPremium
} from '../../common/api/assessment'

const fetchAssessmentFile = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:FETCH',
  params: { assessmentFileId },
  request: () =>
    apiGetAssessmentFile(assessmentFileId, {
      include:
        'assessment_file.assessment_file_invitations,assessment_file.assessment_file_invitation.guest_moderator,assessment_file.assessment_file_invitation.guest_moderator.names,assessment_file.assessment_file_invitation.guest_moderator.email_identity,assessment_file.assessment_file_invitation.guest_moderator.email_identity.email,assessment_file.details,assessment_file.timestamps,assessment_file.student_types,assessment_file.student_type.account,assessment_file.student_type.account.names,assessment_file.contributions,assessment_file.contributors,assessment_file.contributor,assessment_file.account.names,assessment_file.account.avatar,assessment_file.works,assessment_file.policy,assessment_file.close,assessment_file.teacher_types,assessment_file.teacher_type,assessment_file.teacher_type.account,assessment_file.teacher_type.account.names,assessment_file.student_type.year_group,assessment_file.student_type.year_group.names,assessment_file.student_type.year_group.order,assessment_file.benchmark,assessment_file.benchmark.benchmarked_by,assessment_file.benchmark.benchmarked_by.names,assessment_file.guest_moderator_count'
    })
})

const fetchAssessmentFileInvitees = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:FETCH_INVITEES',
  params: { assessmentFileId },
  request: () =>
    apiGetAssessmentFile(assessmentFileId, {
      include:
        'assessment_file.assessment_file_invitations,assessment_file.assessment_file_invitation.guest_moderator,assessment_file.assessment_file_invitation.guest_moderator.names,assessment_file.assessment_file_invitation.guest_moderator.subscriptions,assessment_file.assessment_file_invitation.guest_moderator.email_identity,assessment_file.assessment_file_invitation.guest_moderator.email_identity.email,assessment_file.assessment_file_invitation.details'
    })
})

const fetchAssessmentFileInviteesCounter = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:FETCH_INVITEES_COUNTER',
  params: { assessmentFileId },
  request: () =>
    apiGetAssessmentFile(assessmentFileId, {
      include: 'assessment_file.guest_moderator_count'
    })
})

const openInvitationAssessmentDialog = id => ({
  type: 'ASSESSMENT_FILE_STORE:INVITATION_ASSESSMENT_DIALOG:OPEN',
  params: {
    id
  }
})

const closeInvitationAssessmentDialog = () => ({
  type: 'ASSESSMENT_FILE_STORE:INVITATION_ASSESSMENT_DIALOG:CLOSE'
})

const inviteToAssessmentFile = (
  assessmentFileId,
  emails,
  recaptchaToken,
  message
) => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:INVITE',
  params: { assessmentFileId, emails },
  request: () => {
    const payload = {
      assessment_file_id: assessmentFileId,
      emails,
      recaptcha_token: recaptchaToken
    }
    if (message) payload.message = message
    return apiInviteToAssessmentFileBulk(payload, {
      include:
        'actions,action.details,action.action_object,action.action_object.details,action.action_object.timestamps,action.action_object.account,action.action_object.account.names,action.action_object.guest_moderator,action.action_object.account.email_identity.email'
    })
  }
})

const markAsExample = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:MARK_AS_EXAMPLE',
  params: {
    assessmentFileId
  },
  request: () => apiMarkAsExample(assessmentFileId)
})

const unmarkAsExample = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:UNMARK_AS_EXAMPLE',
  params: {
    assessmentFileId
  },
  request: () => apiUnmarkAsExample(assessmentFileId)
})

const markAsTrainingMaterial = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:MARK_AS_TRAINING_MATERIAL',
  params: {
    assessmentFileId
  },
  request: () => apiMarkAsTrainingMaterial(assessmentFileId)
})

const unmarkAsTrainingMaterial = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:UNMARK_AS_TRAINING_MATERIAL',
  params: {
    assessmentFileId
  },
  request: () => apiUnmarkAsTrainingMaterial(assessmentFileId)
})

const markAsBenchmark = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:MARK_AS_BENCHMARK',
  params: {
    assessmentFileId
  },
  request: () => apiMarkAsBenchmark(assessmentFileId)
})

const unmarkAsBenchmark = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:UNMARK_AS_BENCHMARK',
  params: {
    assessmentFileId
  },
  request: () => apiUnmarkAsBenchmark(assessmentFileId)
})

const closeAssessmentFile = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:CLOSE',
  params: {
    assessmentFileId
  },
  request: () => apiCloseAssessmentFile(assessmentFileId)
})

const reopenAssessmentFile = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:REOPEN',
  params: {
    assessmentFileId
  },
  request: () => apiReopenAssessmentFile(assessmentFileId)
})

const openEditTitleDialog = (
  id,
  title,
  description,
  moderation_type,
  judgement
) => ({
  type: 'ASSESSMENT_FILE_STORE:EDIT_TITLE_DIALOG:OPEN',
  params: {
    id,
    title,
    description,
    moderation_type,
    judgement
  }
})

const closeEditTitleDialog = () => ({
  type: 'ASSESSMENT_FILE_STORE:EDIT_TITLE_DIALOG:CLOSE'
})

const editTitle = (id, title, description, moderation_type, judgement) => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:EDIT',
  params: { id, title, description, moderation_type, judgement },
  request: () =>
    apiEditTitle(id, title, description, moderation_type, judgement)
})

const openInviteesDialog = id => ({
  type: 'ASSESSMENT_FILE_STORE:INVITEES_DIALOG:OPEN',
  params: {
    id
  }
})

const closeInviteesDialog = () => ({
  type: 'ASSESSMENT_FILE_STORE:INVITEES_DIALOG:CLOSE'
})

const markAsPremium = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:MARK_AS_PREMIUM',
  params: {
    assessmentFileId
  },
  request: () => apiMarkAsPremium(assessmentFileId)
})

const unmarkAsPremium = assessmentFileId => ({
  requestPrefix: 'ASSESSMENT_FILE_STORE:UNMARK_AS_PREMIUM',
  params: {
    assessmentFileId
  },
  request: () => apiUnmarkAsPremium(assessmentFileId)
})

export {
  fetchAssessmentFile,
  openInvitationAssessmentDialog,
  closeInvitationAssessmentDialog,
  inviteToAssessmentFile,
  markAsExample,
  unmarkAsExample,
  openEditTitleDialog,
  closeEditTitleDialog,
  editTitle,
  closeAssessmentFile,
  reopenAssessmentFile,
  markAsBenchmark,
  unmarkAsBenchmark,
  markAsTrainingMaterial,
  unmarkAsTrainingMaterial,
  openInviteesDialog,
  closeInviteesDialog,
  fetchAssessmentFileInvitees,
  fetchAssessmentFileInviteesCounter,
  markAsPremium,
  unmarkAsPremium
}
